import requestService from "../requestService";
import store from '@/store';

export default {
    async createReview(form) {
        const response = await requestService.post(`/admin/reviews/create`, form, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async updateReview(uuid, form) {
        const response = await requestService.post(`/admin/reviews/${uuid}/update`, form, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async getReviews() {
        const response = await requestService.get(`/reviews`)
        return response?.data
    },
    async getReview(id) {
        const response = await requestService.get(`/admin/reviews/${id}`, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async deleteReview(id) {
        const response = await requestService.delete(`/admin/reviews/${id}/delete`, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
}